import { makeStyles, MenuItem, MenuList } from "@material-ui/core";

import * as colors from "../../../theme/colors";
import { StyledMenu } from "./styled-menu";

export const ResponsiveNestedMenu = ({ isMobile, ...props }) => {
  const classes = nestedMenuStyles();
  if (!props.open) {
    return null;
  }
  if (isMobile) {
    return (
      <MenuItem classes={{ root: classes.menuItemRoot }}>
        <MenuList className={classes.root}>{props.children}</MenuList>
      </MenuItem>
    );
  }
  return (
    <StyledMenu {...props} style={{ marginTop: 49 }}>
      {props.children}
    </StyledMenu>
  );
};

const nestedMenuStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("md")]: {
      "& > li": {
        minWidth: "auto",
      },
    },
    [theme.breakpoints.down("md")]: {
      "& > li": {
        height: 50,
        justifyContent: "left",
      },
    },
    padding: 0,
    width: "100%",
  },
  menuItemRoot: {
    color: colors.white,
    fontSize: 16,
    fontWeight: 600,
    display: "flex",
    justifyContent: "center",
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,
    "&:hover": {
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: colors.white,
      },
      color: colors.white,
    },
  },
}));
